import { TFunction } from 'i18next';
import { TriviaQuestion } from '../types';

export const getQuestions = (t: TFunction): TriviaQuestion[] => {
  const questions = t('questions', { ns: 'trivia', returnObjects: true }) as unknown as Array<{
    id: number;
    emoji: string;
    text: string;
    options: string[];
    correct_index: number;
    feedback_correct: string;
    feedback_incorrect: string;
  }>;

  return questions.map((q) => ({
    id: q.id,
    emoji: q.emoji,
    text: q.text,
    options: q.options,
    correct_index: q.correct_index,
    feedback_correct: q.feedback_correct,
    feedback_incorrect: q.feedback_incorrect,
  }));
};
